import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import useDataStore from '../Data/dataStore';
import { afterFirstInteraction, API, editorSlug, extractBracketImages, generateSEOText, generateSitemap, getLinks, isBot, saveCanvasAsPNG, saveImagesZip, } from '../globalUtils';
import { sanitize } from '../../utils';
import { useLocation } from 'react-router-dom';
import { getPath } from '../Router/Router';
import { WPImage } from '../UI/WPImage';
const SEOSection = ({ pageContent }) => {
    const urlPath = useLocation().pathname;
    const isEditorURL = getPath(urlPath) === editorSlug;
    const [seo, setSeo] = useState('');
    const [preloadImages, setPreloadImages] = useState([]);
    const [warmImageCache, setWarmImageCache] = useState(false);
    const data = useDataStore((state) => state.data);
    const { legal, seo_filter } = data[API.setup] ?? '';
    useEffect(() => {
        document.addEventListener('keydown', printSitemap);
        return () => document.removeEventListener('keydown', printSitemap);
    }, []);
    // Crawlers get the images in the first render; everyone else gets them once
    // they have actually engaged with the page. See the note on the block itself.
    useEffect(() => {
        if (isBot)
            return;
        return afterFirstInteraction(() => setWarmImageCache(true));
    }, []);
    useEffect(() => {
        const seoFilter = seo_filter?.replace(/\s+/g, '').split(',');
        const seoTextWithImages = generateSEOText(data, pageContent, seoFilter ?? [], legal);
        const { text, images } = extractBracketImages(seoTextWithImages);
        setPreloadImages(images);
        setSeo(text);
    }, [data, pageContent, seo_filter]);
    const printSitemap = (evt) => {
        if (isEditorURL) {
            const data = useDataStore.getState().data;
            if (evt.code === 'Digit0' && evt.altKey && evt.shiftKey) {
                if (data) {
                    generateSitemap(getLinks(data).map((item) => item.link));
                }
                evt.stopPropagation();
                evt.preventDefault();
            }
            if (evt.code === 'KeyI' && evt.altKey && evt.shiftKey) {
                saveImagesZip(data);
            }
            if (evt.code === 'KeyE' && evt.altKey && evt.shiftKey) {
                saveCanvasAsPNG('canvas');
            }
        }
    };
    return (_jsxs("div", { className: `page-content${!isBot ? ' hidden' : ''}`, children: [_jsx("div", { dangerouslySetInnerHTML: {
                    __html: sanitize(seo),
                } }), (isBot || warmImageCache) && (_jsx("div", { className: `preload-images${isBot ? '' : ' warming'}`, children: preloadImages.map((id, idx) => (_jsx(WPImage, { id: id }, `${id}-${idx}`))) }))] }));
};
export default SEOSection;
